import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMasterData } from "../services/Apis";

export const fetchMasterData = createAsyncThunk("fetchMasterData", async () => {
    const response = await getMasterData();
    return response.data;
});

const globalslice = createSlice({
    name: "globalslice",
    initialState: {
        auth_status: false,
        initial_page: 1,
        perPage: 10,
        initial_page1: 1,
        sorting_data: {},
        sorting_data1: {},
        profile_Details: {},
        auth_token: '',
        fcm_token: '',
        insert_id: '',
        sectioninsert_id: '',
        isAdmin: false,
        searchinput: true,
        open_modal: false,
        order_modal: false,
        orderSelectedproducts: [],
        masterdata: null,
        isLoadingMatser: false,
        hristabs: 1,
        staffFormData: {},
        staffid: "",
        staffbascicpay: "",
        salarynetprice: "",
        auditid: "",
        projectslider: [],
        projectspecificaton: [],
        checklistid: "",
        agent_id : "",
        auditid: "",
        imageloader:false,
    },
    
    reducers: {
        setauth_token: (state, action) => {
            state.auth_token = action.payload; // Update hastoggle to true
        },
        setimageloader: (state, action) => {
            state.imageloader = action.payload; // Update hastoggle to true
        },
        setfcm_token: (state, action) => {
            state.fcm_token = action.payload; // Update hastoggle to true
        },
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload; // Update hastoggle to true
        },
        setopen_modal: (state, action) => {
            state.open_modal = action.payload; // Update hastoggle to true
        },
        setstaffbascicpay: (state, action) => {
            state.staffbascicpay = action.payload;
        },
        setauth_status: (state, action) => {
            state.auth_status = action.payload;
        },
        setprofile_Details: (state, action) => {
            state.profile_Details = action.payload;
        },
        setinitial_page: (state, action) => {
            state.initial_page = action.payload;
        },
        setperPage: (state, action) => {
            state.perPage = action.payload;
        },
        setinitial_page1: (state, action) => {
            state.initial_page1 = action.payload;
        },
        setsorting_data: (state, action) => {
            state.sorting_data = action.payload;
        },
        setsorting_data1: (state, action) => {
            state.sorting_data1 = action.payload;
        },
        setinsert_id: (state, action) => {
            state.insert_id = action.payload;
        },
        setsectionInsert_id: (state, action) => {
            state.sectioninsert_id = action.payload;
        },
        setorderSelectedproducts: (state, action) => {
            state.orderSelectedproducts = action.payload; // for in orderpage selected products 
        },
        setsearchinput: (state, action) => {
            state.searchinput = action.payload; // for in orderpage selected products 
        },
        setorder_modal: (state, action) => {
            state.order_modal = action.payload; // for in orderpage selected products 
        },
        sethristabs: (state, action) => {
            state.hristabs = action.payload;
        },
        setStaffFormData: (state, action) => {
            state.staffFormData = { ...state.staffFormData, ...action.payload };
        },
        setstaffid: (state, action) => {
            state.staffid = action.payload;
        },
        setsalarynetprice: (state, action) => {
            state.salarynetprice = action.payload;
        },
        setauditid: (state, action) => {
            state.auditid = action.payload;
        },
        setprojectslider: (state, action) => {
            state.projectslider = action.payload;
        },
        setprojectspecificaton: (state, action) => {
            state.projectspecificaton = action.payload;
        },
        setchecklistid: (state, action) => {
            state.checklistid = action.payload;
        },
        setAgentid: (state, action) => {
            state.agent_id = action.payload;
        },
    },
    extraReducers: (builder) => {
        //Get Master List
        builder.addCase(fetchMasterData.pending, (state, action) => {
            state.isLoadingMatser = true;
        });
        builder.addCase(fetchMasterData.fulfilled, (state, action) => {
            state.isLoadingMatser = false;
            state.masterdata = action.payload;
        });
        builder.addCase(fetchMasterData.rejected, (state, action) => {
            state.isError = true;
        });
    }
});
export const { setauth_token, setStaffFormData,setimageloader, setchecklistid, setprojectslider, setprojectspecificaton, setstaffid, setstaffbascicpay, setsalarynetprice, setopen_modal, sethristabs, setfcm_token, setorder_modal, setauth_status, setinitial_page, setperPage, setinitial_page1, setsearchinput, setsorting_data, setsorting_data1, setinsert_id, setorderSelectedproducts, setIsAdmin, setprofile_Details, setsectionInsert_id, setauditid, setAgentid} = globalslice.actions
export default globalslice.reducer;
